<template>
  <div class="app-header bg-black">
    <!--{{appName}} - -->{{appSubName}}
    <!--<?=$_ENV["APP_NAME"]?>-->
    <a href="javascript:void(0)" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{userName}}
      <!--<?=$_SESSION['authuser']?>-->
    </a>
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
      <!--<a class="dropdown-item" href="#">Settings</a>-->
      <!--<a class="dropdown-item" href="#">Activity Log</a>-->
      <!--<div class="dropdown-divider"></div>-->
      <!--<a class="dropdown-item" href="javascript:void(0)" @click="page('logout')">Logout</a>-->
    </div>
  </div>
</template>

<script>
  import {appName, appSubName} from './../../../.env.js'

  export default {
    name: 'MainHeader',
    data() {
      return {
        userName: localStorage.getItem('username'),
        appName: appName,
        appSubName: appSubName
      }
    },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/mobileapps/layout/MainHeader.vue